import React from "react";
import { useGetAddress } from "../../hooks/api/fh/useGetAddress";

function Address({ fh_id }) {
  const { data } = useGetAddress(fh_id);
  if (!data || data?.length === 0) return null;

  return (
    <div className="cell small-12 form-section">
      <h2 className="heading-underline">Address Details</h2>
      <div className="table-contacts-wrap">
        <table className="table-contacts">
          <thead>
            <tr>
              <th>Name</th>
              <th>Address</th>
              <th>City</th>
              <th>State</th>
              <th>Postcode</th>
            </tr>
          </thead>

          {data.map((address) => {
            return (
              <tbody key={address.id} className="contact-entry">
                <td>{address.address_name}</td>
                <td>{address.address_line_1}</td>
                <td>{address.address_city}</td>
                <td>{address.address_state}</td>
                <td>{address.address_postcode}</td>
              </tbody>
            );
          })}
        </table>
      </div>
    </div>
  );
}

export default Address;
